import { useEffect, useState } from 'react';

/**
 * Ticks at the next quarter-hour boundary (:00, :15, :30, :45) and every 15 minutes thereafter.
 */
export function useQuarterTick(): number {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | null = null;

    const scheduleNextQuarter = () => {
      const now = new Date();

      // Calculate delay to the next quarter-hour boundary
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const ms = now.getMilliseconds();

      const quartersPassed = minutes % 15;
      const minutesToAdd =
        quartersPassed === 0 && seconds === 0 && ms === 0
          ? 15 // exactly on a boundary -> schedule the *next* one
          : 15 - quartersPassed;

      const next = new Date(now);
      next.setSeconds(0, 0);
      next.setMinutes(minutes + minutesToAdd);

      const delay = next.getTime() - now.getTime();

      timer = setTimeout(() => {
        setTick((t) => t + 1);
        if (!cancelled) scheduleNextQuarter();
      }, delay);
    };

    scheduleNextQuarter();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, []);

  return tick;
}
